import React, { useEffect } from "react";
import { valid } from "node-html-parser";
import { Button, Grid, Typography } from "@mui/material";
import QuestionCodeEditor from "./QuestionCodeEditor";
import QuestionCodeWindow from "./QuestionCodeWindow";

export default function CodeField(props) {
  
  const [correctList, setCorrectList] = React.useState([])

  useEffect(() => {
    checklistGrade(props.checklist)
  }, [props.checklist])

  const checklistGrade = (checklist) => {
    let correct = [];
    for (let test of checklist) {
        try {
          if (document.getElementById(props.name + "target").contentWindow.eval(test)) {
            correct.push(true);
          } else {
            correct.push(false);
          }
        } catch (err) {
          console.log(err);
          correct.push(false)
        }
      }
      
      setCorrectList(correct)
  }
  
  return (
    <>
      <Grid container direction="row">
        <QuestionCodeEditor sx={{width:"49%", paddingRight:"5px"}} item {...props}/>
        <QuestionCodeWindow sx={{width:"50%"}} item {...props}/>
      </Grid>
      
      {props.showChecks && <Button sx={{margin:"10px"}} variant="contained" onClick={() => checklistGrade(props.checklist)}>Run Checks</Button>}
      {props.showChecks && correctList.map((correct, i) => {
        if (correct) {
          return <Typography color="primary.green" fontWeight="bold" key={i}>{i+1}. {props.checklist[i]} Passes</Typography>          
        } else {
          return <Typography color="secondary" fontWeight="bold" key={i}>{i+1}. {props.checklist[i]} Fails</Typography>
        }
      })}
    </>
  );
}


